import { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { formatClock, secondsLeft } from '../utils/rounds';

interface RoundCountdownProps {
  closesAt: string | null;
  serverNow: string;
  fetchedAt: number;
}

/** Time left in a timed round, measured against the server clock */
export function RoundCountdown({ closesAt, serverNow, fetchedAt }: RoundCountdownProps) {
  const [, tick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, []);
  const left = secondsLeft(closesAt, serverNow, fetchedAt);
  if (left === null) return null;
  return (
    <span className={`inline-flex items-center gap-1 font-mono text-sm ${left <= 30 ? 'font-semibold text-destructive' : 'text-muted-foreground'}`}>
      <Timer className="size-4" /> {formatClock(left)}
    </span>
  );
}
